// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2eBzo","imageUploader":"EGiftCard_imageUploader__3HYlj"};